export default [
  {
    path: '/content/information/InformationMain',
    component: resolve => require(['../pages/information/InformationMain.vue'], resolve),
    title: '更多资讯'
  },
  {
    path: '/content/information/InformationDetail',
    component: resolve => require(['../pages/information/InformationDetail.vue'], resolve),
    title: '动态和资讯详情'
  }
];



// WEBPACK FOOTER //
// ./src/content/portalSite/router/InformationRouter.js